import type { PregnancyWeek, PregnancyWeekDraft } from '@domain/entities';
import type { PregnancyRepository } from '@domain/repositories';
import type { UseCase } from '../use-case';

export class ListPregnancyWeeks implements UseCase<string, PregnancyWeek[]> {
  constructor(private readonly repo: PregnancyRepository) {}
  execute(search: string): Promise<PregnancyWeek[]> {
    return this.repo.list(search);
  }
}

export class GetPregnancyWeek implements UseCase<number, PregnancyWeek> {
  constructor(private readonly repo: PregnancyRepository) {}
  execute(week: number): Promise<PregnancyWeek> {
    return this.repo.get(week);
  }
}

export interface SaveWeekInput {
  week: number;
  draft: PregnancyWeekDraft;
}

export class SavePregnancyWeek implements UseCase<SaveWeekInput, PregnancyWeek> {
  constructor(private readonly repo: PregnancyRepository) {}
  execute({ week, draft }: SaveWeekInput): Promise<PregnancyWeek> {
    return this.repo.save(week, draft);
  }
}

export class ValidatePregnancyWeek implements UseCase<number, PregnancyWeek> {
  constructor(private readonly repo: PregnancyRepository) {}
  execute(week: number): Promise<PregnancyWeek> {
    return this.repo.validate(week);
  }
}
